export default {
	HASH: 'HASH',
}